import * as React from "react";
import { Grid } from "../grid/grid";
import { GridItem } from "../grid/griditem";
import { RevoTooltip } from "./revo-tooltip";
import { Icon } from "./icon";
import { find } from "../better/array";
import { getThemeColorVar } from "../helper/color";
import { css, cx } from "emotion";
const arrowClass = css({
    color: getThemeColorVar("typo", "light"),
});
const valueClass = css({
    backgroundColor: getThemeColorVar("white", undefined),
    border: `1px solid ${getThemeColorVar("secondary1", "default")}`,
    width: "24px",
    height: "24px",
    borderRadius: "20px",
    cursor: "pointer",
});
const innerValueClass = css({
    width: "18px",
    height: "18px",
    borderRadius: "15px",
});
const selectedClass = css({
    backgroundColor: getThemeColorVar("secondary1", "default"),
});
export const FlowSlider = (props) => {
    const selectedValue = find(props.values, (value) => value.value === props.selectedValue);
    return (React.createElement("div", null,
        React.createElement(Grid, { columns: props.values.length + props.values.length - 1, rowGap: "md" },
            props.withoutHeader ? null : (React.createElement(React.Fragment, null,
                React.createElement(GridItem, { key: "label", colStart: 1, colEnd: -1, justifySelf: "center", alignSelf: "center" },
                    React.createElement("strong", null, selectedValue ? selectedValue.label : "[i18n] unknown")),
                React.createElement(GridItem, { key: "divider", colStart: 1, minWidth: [80, "%"], colEnd: -1, justifySelf: "center", alignSelf: "center" },
                    React.createElement("hr", null)))),
            props.values.map((value, index) => {
                const classes = value.value == props.selectedValue
                    ? [innerValueClass, selectedClass]
                    : [innerValueClass];
                return (React.createElement(React.Fragment, { key: value.value },
                    index !== 0 ? (React.createElement(GridItem, { justifySelf: "center", alignSelf: "center" },
                        React.createElement("div", { className: cx(arrowClass) },
                            React.createElement(Icon, { size: "regular", name: "chevron_right" })))) : undefined,
                    React.createElement(GridItem, { justifySelf: "center" },
                        React.createElement(RevoTooltip, { text: value.label, position: "down" },
                            React.createElement("div", { onClick: () => props.onValueChange(value.value), className: cx(valueClass) },
                                React.createElement(Grid, { height: [100, "%"], columns: 1 },
                                    React.createElement(GridItem, { justifySelf: "center", alignSelf: "center" },
                                        React.createElement("div", { className: cx(classes) }))))))));
            }))));
};
export default FlowSlider;
//# sourceMappingURL=flowslider.js.map